import {
  jb_multi_column_css_default
} from "./chunk.XSCOARZF.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  ChangesBackgroundColor
} from "./chunk.XYH4LHGJ.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  o
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-multi-column/jb-multi-column.ts
var JbMultiColumn = class extends Spaceable(ChangesBackgroundColor(i)) {
  async firstUpdated() {
    await this.updateComplete;
    this._addClassToLast(this._firstSlotElements);
    this._addClassToLast(this._secondSlotElements);
    this._addClassToLast(this._thirdSlotElements);
  }
  _addClassToLast(slotElement) {
    if (slotElement && slotElement.length > 0) {
      slotElement[slotElement.length - 1].classList.add("last");
    }
  }
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 12, type: "no-vertical-space" };
  }
  render() {
    return b`
      ${this.kicker ? b`<div
              class="slots ${e({
      twocolumn: this.columns === 2,
      threecolumn: this.columns === 3,
      narrow: !!this.narrow
    })}"
            >
              <jb-heading>${this.kicker}</jb-heading>
            </div>` : A}
      <jb-heading-context offset=${this.kicker ? 1 : 0}>
        <div
          class="slots ${e({
      twocolumn: this.columns === 2,
      threecolumn: this.columns === 3,
      narrow: !!this.narrow
    })}"
        >
          <div><slot name="first"></slot></div>
          <div><slot name="second"></slot></div>
          ${this.columns === 3 ? b`<div><slot name="third"></slot></div>` : A}
        </div>
      </jb-heading-context>
    `;
  }
};
JbMultiColumn.styles = [reset_css_default, jb_multi_column_css_default];
__decorateClass([
  n({ type: Number })
], JbMultiColumn.prototype, "columns", 2);
__decorateClass([
  n()
], JbMultiColumn.prototype, "kicker", 2);
__decorateClass([
  n({ type: Boolean })
], JbMultiColumn.prototype, "narrow", 2);
__decorateClass([
  o({ slot: "first" })
], JbMultiColumn.prototype, "_firstSlotElements", 2);
__decorateClass([
  o({ slot: "second" })
], JbMultiColumn.prototype, "_secondSlotElements", 2);
__decorateClass([
  o({ slot: "third" })
], JbMultiColumn.prototype, "_thirdSlotElements", 2);
JbMultiColumn = __decorateClass([
  customElement("jb-multi-column")
], JbMultiColumn);

export {
  JbMultiColumn
};
